// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=0980c546-8dd3-4b97-bfa2-a2eaefc694ec";
};